@if (lss.isLoading$ | async) {
  <div class="overlay">
    <div class="center">
      <mat-spinner diameter="80" color="default"></mat-spinner>
    </div>
  </div>
}